import { Injectable } from '@angular/core';
import { NavDriverService } from '../nav-driver/nav-driver.service';
import { ProfileService } from '../profile/profile.service';
import { Driver } from './mappings/mappings.model';
import { MappingsService } from './mappings/mappings.service';
import { Platform } from '@ionic/angular';

@Injectable({
  providedIn: 'root',
})
export class NavProcessingService {
  constructor(
    private driver: NavDriverService,
    private profile: ProfileService,
    private mappings: MappingsService,
    private plt: Platform
  ) {
    // this.profile.mappingsSettings$.subscribe((settings) => {
    //   // collects all necessary drivers from the mappings service settings (mapping.movement.driver) and updates
    //   // the driver service with the new drivers using the updateDriverRegistry function
    //   const drivers = settings.mappings
    //     .filter((mapping) => mapping.enabled)
    //     .map((mapping) => // Trata versões antigas do settings que não possuem driver
    //       mapping.movement?.driver ? mapping.movement.driver : Driver.face
    //     );
    //   this.driver.updateDriverRegistry(drivers, true);
    // });
    
    //plt.ready().then(() => {
      //this.mappings.setProfile(profile.profile);
    //});

    this.profile.profile$.subscribe((profile) => {
      let drivers: Driver[] = [];

      if(profile.navSettingsBundle) {
        this.mappings.setProfile(profile);
      } else {
        // LEGADO
        console.log('LEGACY NavProcessingService');
        // profile.mappingsServiceSettings?.mappings.forEach((mapping) => {
        //   if (mapping.enabled) {
            
        //     drivers.push(mapping.movement.driver);
        //   }
        // });
      }
      // collects all necessary drivers from the profile service settings (profile.movement.driver) and updates
      // the driver service with the new drivers using the updateDriverRegistry function
      this.mappings.settings.mappings?.forEach((mapping) => {
        if (mapping.enabled) {
          // Trata versões antigas do settings que não possuem driver
          mapping.movement.driver = mapping.movement?.driver ? mapping.movement.driver : [Driver.face]
          if (mapping.movement.driver instanceof Array) {
            mapping.movement.driver.forEach((driver) => {
              drivers.push(driver);
            });
          } else {
            drivers.push(mapping.movement.driver);
          }
          console.log('mapping.movement.driver', mapping.movement.driver);
        }
      });
      this.driver.updateDriverRegistry(drivers, true);
    });
  }
}
